export class NoticeSettings {
  constructor(overrides = {}) {
    const defaults = {
      width: { type: 'px', value: 600 },
      height: { type: 'auto', value: 1 },
      padding: { paddingLeft: 10, paddingRight: 10, paddingTop: 10, paddingBottom: 10 },
      border: { borderWidth: 0, borderColor: '#000000', borderTopLeftRadius: 10, borderTopRightRadius: 10, borderBottomLeftRadius: 10, borderBottomRightRadius: 10, borderStyle: 'solid' },
      background: '#ffffff',
      closeAlign: 'right',
      closeFont: { fontSize: 16, fontWeight: '500', color: '#999999', fontFamily: 'arial, helvetica, sans-serif' },
      showClose: true,
      showVeil: true,
      lockScroll: true,
      veilColor: '#000000',
      veilOpacity: 0.65,
      type: 'modal',
      url: '',
      type_settings: { targetType: 'id', targetName: '' },
    };
    Object.assign(this, defaults, overrides);
  }
}

export const NoticeTypes = {
  settings: {
    type: { title: 'Message Type', type: 'Type' },
    lockScroll: { title: 'Disable Scrolling?', type: 'Switch' },
    url: { title: 'Website BG', type: 'Input' },
  },
  orientation: {
    width: { title: 'Width', type: 'Size' },
    height: { title: 'Height', type: 'Size' },
    padding: { title: 'Padding', type: 'Padding' },
  },
  styles: {
    background: { title: 'Background Color', type: 'ColorPicker' },
    border: { title: 'Border', type: 'Border' },
  },
  close: {
    showClose: { title: 'Show?', type: 'Switch' },
    closeAlign: { title: 'Align', type: 'Align' },
    closeFont: { title: 'Style', type: 'Font' },
  },
  veil: {
    showVeil: { title: 'Show?', type: 'Switch' },
    veilColor: { title: 'Color', type: 'ColorPicker' },
    veilOpacity: { title: 'Opacity', type: 'Opacity' },
  },
};